import SectionBannerKnowledge from "../../components/main/SectionBannerKnowledge";
import SectionBlogList from "../../components/main/SectionBlogList";
import SectionQuestion from "../../components/main/SectionQuestion";
import PandaQuestion1 from "../../assets/images/Panda/PandaQuestion1.png";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const Knowledge: React.FC = () => {
  const faqs = [
    {
      key: "1",
      q: "Làm thế nào để tối ưu SEO cho website?",
      a: "Tối ưu SEO bao gồm: tối ưu từ khóa, tốc độ tải trang, mobile-friendly, nội dung chất lượng, liên kết nội bộ và backlink.",
    },
    {
      key: "2", 
      q: "Xu hướng thiết kế web 2024 là gì?",
      a: "Xu hướng 2024 bao gồm: Dark mode, Minimalism, AI chatbot, Progressive Web App, Voice UI và AR/VR integration.",
    },
    {
      key: "3",
      q: "Cách chọn công nghệ phù hợp cho dự án web?",
      a: "Cần xem xét: quy mô dự án, yêu cầu tính năng, đội ngũ phát triển, ngân sách và thời gian triển khai.",
    },
    {
      key: "4",
      q: "Bảo mật website cần lưu ý những gì?",
      a: "SSL Certificate, cập nhật thường xuyên, backup dữ liệu, xác thực 2 lớp, validate input và monitor hệ thống.",
    },
    {
      key: "5",
      q: "Performance optimization cho website?",
      a: "Tối ưu hình ảnh, minify code, sử dụng CDN, caching, lazy loading và chọn hosting chất lượng cao.",
    },
  ];

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Trang chủ",
        "item": "https://triocoresolutions.com.vn/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Kiến thức",
        "item": "https://triocoresolutions.com.vn/knowledge"
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Kiến Thức — TrioCore Solutions"
        description="Kho tài liệu chia sẻ kiến thức thiết kế website, lập trình phần mềm và các chiến lược digital marketing từ đội ngũ TrioCore Solutions."
        path="/knowledge"
      />
      <JsonLd data={breadcrumbData} />
      <SectionBannerKnowledge />
      <SectionBlogList />
      <SectionQuestion 
        title="Câu hỏi thường gặp về Kiến thức Web" 
        faqs={faqs} 
        img={<img className="w-[470px] object-cover absolute top-5 left-5" src={PandaQuestion1} alt="Panda Mascot" width="470" height="470" loading="lazy" />} 
      />
    </>
  );
};

export default Knowledge;